import { Link } from "@remix-run/react"
import clsx from "clsx"
import { Fragment, useState } from "react"
import { useOptionalUser } from "#app/utils/user"
import { ThemeSwitch } from "./theme-switch"
import { Icon } from "./ui/icon"
import { UserDropdown } from "./user-dropdown"

const navigation = [
	{ name: "Product", href: "/product" },
	// { name: "Solutions", href: "/solutions" },
	{ name: "Parenting Resources", href: "/resources" },
	{ name: "About Us", href: "/about" },
	{ name: "Support", href: "/support" },
]

const NavigationMarketing = () => {
	const user = useOptionalUser()
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
	return (
		<div className="relative top-0 z-50 lg:sticky lg:-mx-3">
			<header className="container relative rounded-xl bg-primary-foreground text-text">
				<nav
					className="my-4 flex items-center justify-between py-4 lg:px-4 xl:px-6"
					aria-label="Global"
				>
					<div className="flex lg:flex-1">
						<Link to="/" className="-m-1.5 p-1.5">
							<div className="text-xl font-medium">presentparent.ai</div>
						</Link>
					</div>
					<button
						className="lg:hidden"
						aria-controls="mobile-menu"
						aria-expanded="false"
						onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
					>
						<span className="sr-only">Open main menu</span>
						{/* <Icon name="bars" className="h-6 w-6" /> */}
						{mobileMenuOpen ? (
							<Icon name="times" className="h-6 w-6" />
						) : (
							<svg
								className="h-6 w-6"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								aria-hidden="true"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="2"
									d="M4 6h16M4 12h16m-7 6h7"
								/>
							</svg>
						)}
					</button>
					<div className="hidden lg:flex lg:gap-x-6 lg:pl-4 xl:gap-x-12">
						{navigation.map(item => (
							<Link
								key={item.name}
								to={item.href}
								className="cursor-pointer text-sm font-semibold leading-6"
							>
								{item.name}
							</Link>
						))}
					</div>
					<div className="hidden items-center gap-x-2 lg:flex lg:flex-1 lg:justify-end">
						{user ? (
							<Fragment>
								<UserDropdown />
							</Fragment>
						) : (
							<Link
								to="/login"
								className="cursor-pointer text-sm font-semibold leading-6"
							>
								Log in <span aria-hidden="true">&rarr;</span>
							</Link>
						)}
						<ThemeSwitch />
					</div>
					<div
						className={clsx("absolute left-0 right-0 top-16 bg-background", {
							hidden: !mobileMenuOpen,
							"lg:hidden": mobileMenuOpen,
						})}
						id="mobile-menu"
					>
						<div className="space-y-1 px-2 pb-3 pt-2">
							{navigation.map(item => (
								<Link
									key={item.name}
									to={item.href}
									className="block rounded-md px-3 py-2 text-base font-medium"
								>
									{item.name}
								</Link>
							))}
						</div>
						<div className="mb-4 flex justify-end gap-x-2 px-4">
							{user ? (
								<Fragment>
									<UserDropdown />
								</Fragment>
							) : (
								<Link
									to="/login"
									className="block rounded-md px-3 py-2 text-base font-medium"
								>
									Log in <span aria-hidden="true">&rarr;</span>
								</Link>
							)}
							<ThemeSwitch />
						</div>
					</div>
				</nav>
				{/* Rest of the header component */}
			</header>
		</div>
	)
}

export default NavigationMarketing
